var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbJointTrustPlan = function SvgAbJointTrustPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 424,
    height: 94,
    fill: "none",
    viewBox: "0 0 424 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B5563",
    d: "M176 59.5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-16a2 2 0 0 1-2-2zM228 59.5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-16a2 2 0 0 1-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M212.5 42.263c0 1.933 1.567 3.734 3.5 3.734h18a4.5 4.5 0 0 1 4.5 4.5V57.5h-1v-7.003a3.5 3.5 0 0 0-3.5-3.5h-18c-1.742 0-3.252-1.106-4-2.623-.748 1.517-2.258 2.623-4 2.623h-18a3.5 3.5 0 0 0-3.5 3.5V57.5h-1v-7.003a4.5 4.5 0 0 1 4.5-4.5h18c1.933 0 3.5-1.801 3.5-3.734V28.5h1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B5563",
    d: "M220 24.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
  })));
};
export default SvgAbJointTrustPlan;